import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=95cb3932"
import script from "./Setting.ts?vue&type=script&lang=ts&external"
export * from "./Setting.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports